document.querySelectorAll('input[type="number"][max]').forEach((input) => {
  // Сохраняем предыдущее корректное значение
  input.dataset.prev = input.value;

  input.addEventListener('input', (e) => {
    const max = Number(input.max);
    const value = Number(input.value);

    if (isNaN(value)) {
      input.dataset.prev = '';
      return;
    }

    // если больше max → возвращаем предыдущее значение
    if (value > max) {
      input.value = input.dataset.prev;
    } else {
      input.dataset.prev = input.value;
    }
  });
});
